// extracted by mini-css-extract-plugin
module.exports = {"title":"Multimedia_title__LLG8H","infoIcon":"Multimedia_infoIcon__zRKyO","fileInputContainer":"Multimedia_fileInputContainer__hR2Vs"};